export let Code = {
type: `@Component({
    selector: 'p-splitButton',
    template:
        <p-splitButton label="Default" icon="fa ion-checkmark-round" [model]="items"></p-splitButton>
        <p-splitButton label="Secondary" icon="fa ion-checkmark-round" [model]="items" styleClass="ui-button-secondary"></p-splitButton>
        <p-splitButton label="Success" icon="fa ion-checkmark-round" [model]="items" styleClass="ui-button-success"></p-splitButton>
        <p-splitButton label="Info" icon="fa ion-checkmark-round" [model]="items" styleClass="ui-button-info"></p-splitButton>
        <p-splitButton label="Warning" icon="fa ion-checkmark-round" [model]="items" styleClass="ui-button-warning"></p-splitButton>
        <p-splitButton label="Danger" icon="fa ion-checkmark-round" [model]="items" styleClass="ui-button-danger"></p-splitButton>
})
export class SplitButton {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/splitButton.ts